import { useState, useEffect } from "react";

const useLocalData = (key) => {
  // State to hold the parsed JSON value
  const [value, setValue] = useState(null);

  useEffect(() => {
    // Function to parse JSON from local storage
    const parseJsonFromLocalStorage = () => {
      const storedValue = localStorage.getItem(key);
      try {
        if (storedValue) {
          // Parse the JSON and update the state
          const parsedValue = JSON.parse(storedValue);
          setValue(parsedValue);
        }
      } catch (error) {
        setValue(storedValue);
      }
    };

    // Initial parse when the component mounts
    parseJsonFromLocalStorage();

    // Listen for storage events to update the value if it changes in another tab/window
    const handleStorageChange = (event) => {
      if (event.key === key) {
        parseJsonFromLocalStorage();
      }
    };

    // Attach the event listener
    window.addEventListener("storage", handleStorageChange);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [key]); // Re-run effect when the key changes

  return value;
};

export default useLocalData;
